import { render, staticRenderFns } from "./SuccessAndFail.vue?vue&type=template&id=165131d1&scoped=true"
import script from "./SuccessAndFail.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessAndFail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165131d1",
  null
  
)

export default component.exports